import React from "react";
import { PlantedAcresSvg } from "assets/icons/PlantedAcresSvg";
import { Button } from "react-bootstrap";
import { NO_PLANTED_ACRES_FOUND } from "configurations/MessageConstants";
import { useSelector } from "react-redux";

const EmptyPlantedAcres = ({ onAddPlantedAcres }) => {
  const selectedSite = useSelector((state) => state.site.selectedSite);
  const isSharedViewOnly = selectedSite.isShared && !selectedSite.editor;
  return (
    <div className="text-center d-flex flex-column align-items-center my-2">
      <PlantedAcresSvg />
      <span className="text-muted my-2">{NO_PLANTED_ACRES_FOUND}</span>
      {!isSharedViewOnly && (
        <Button
          variant="outline-dark"
          size="sm"
          className="rounded-pill"
          onClick={onAddPlantedAcres}
        >
          <i className="fa fa-circle-plus me-1"></i>
          Planted Acres
        </Button>
      )}
    </div>
  );
};

export default EmptyPlantedAcres;
